import React from "react";
import { useSelector } from "react-redux";
import Icon from "@mdi/react";
import { mdiCalendarRemoveOutline } from "@mdi/js";
import BookingHeader from "./BookingHeader";

const BookingLinkError = () => {
  const { companyInfo } = useSelector((state) => state.publicClientBooking);

  return (
    <div className="public-client-booking-container">
      <BookingHeader
        companyName={companyInfo?.name}
        companyLogo={companyInfo?.logo}
      />
      <main className="public-client-booking-outcome-main">
        <div className="public-client-booking-failure-icon-wrapper">
          <Icon path={mdiCalendarRemoveOutline} size={1.5} color="#fff" />
        </div>

        <h1 className="public-client-booking-outcome-title">
          Booking link inactive
        </h1>
        <p className="public-client-booking-outcome-subtitle">
          Scheduling is currently disabled.
          <br />
          Please contact the inspector to book your inspection.
        </p>
      </main>
    </div>
  );
};

export default BookingLinkError;
